import React from 'react'
import { Link } from 'react-router-dom'
import Icon from './icons'
import Workflow from './Workflow'

// Ported from the source project's src/components/site/Hero.tsx, framer-motion entrance
// animation dropped (this repo has no framer-motion dependency; Nav/Footer set the same
// precedent in Task 3 - CSS-only presentation, no animation library).
//
// The right column is an animated digital-workflow illustration. It replaced a mock "case
// management portal" card and a three.js particle scene; the portal already has its own
// section further down the page.
const Hero = ({ section, heroStats, heroWorkflow }) => {
    const c = section.content ?? {};
    const titleLines = c.titleLines ?? [section.title ?? ''];
    const emphasisFrom = c.emphasisFrom ?? titleLines.length;
    const primaryCta = c.primaryCta ?? 'Submit a case';
    const secondaryCta = c.secondaryCta ?? 'Request fee schedule';

    return (
        <section className="hero-section" id="top">
            <div className="hero">
                <div className="hero-content">
                    <h1>
                        {titleLines.map((line, i) => (
                            <span key={i}>
                                {i >= emphasisFrom ? <em>{line}</em> : line}
                                {i < titleLines.length - 1 && <br />}
                            </span>
                        ))}
                    </h1>
                    <p className="hero-desc">{section.subtitle}</p>
                    <div className="hero-actions">
                        <Link className="btn-lg" to="/contant">
                            {primaryCta}
                            <Icon name="arrow" />
                        </Link>
                        <Link className="btn-lg-ghost" to="/contant">{secondaryCta}</Link>
                    </div>
                    <div className="hero-stats">
                        {heroStats.map((st) => (
                            <div key={st.order}>
                                <div className="stat-val">{st.value}</div>
                                <div className="stat-label">{st.label}</div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="hero-visual">
                    <Workflow block={heroWorkflow} />
                </div>
            </div>
        </section>
    );
};

export default Hero;
